/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsReferences,
    SharedserviceMelcoModelsReferencesFromJSON,
    SharedserviceMelcoModelsReferencesFromJSONTyped,
    SharedserviceMelcoModelsReferencesToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoFusionModelsBlankReferences
 */
export interface SharedserviceMelcoFusionModelsBlankReferences {
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsReferences>}
     * @memberof SharedserviceMelcoFusionModelsBlankReferences
     */
    custom_product_list?: Array<SharedserviceMelcoModelsReferences> | null;
}

export function SharedserviceMelcoFusionModelsBlankReferencesFromJSON(json: any): SharedserviceMelcoFusionModelsBlankReferences {
    return SharedserviceMelcoFusionModelsBlankReferencesFromJSONTyped(json, false);
}

export function SharedserviceMelcoFusionModelsBlankReferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoFusionModelsBlankReferences {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'custom_product_list': !exists(json, 'custom_product_list') ? undefined : (json['custom_product_list'] === null ? null : (json['custom_product_list'] as Array<any>).map(SharedserviceMelcoModelsReferencesFromJSON)),
    };
}

export function SharedserviceMelcoFusionModelsBlankReferencesToJSON(value?: SharedserviceMelcoFusionModelsBlankReferences | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'custom_product_list': value.custom_product_list === undefined ? undefined : (value.custom_product_list === null ? null : (value.custom_product_list as Array<any>).map(SharedserviceMelcoModelsReferencesToJSON)),
    };
}


